import React from 'react';

interface UserMessageProps {
  content: string;
  timestamp: Date;
  userInitials: string;
}

export function UserMessage({ content, timestamp, userInitials }: UserMessageProps): React.ReactElement {
  return (
    <div className="flex items-start justify-end gap-2 mb-4">
      <div className="flex flex-col items-end max-w-[80%]">
        <div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white rounded-2xl rounded-tr-sm px-4 py-2 shadow-sm">
          <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
        </div>
        <span className="text-xs text-gray-400 mt-1 px-2">
          {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </span>
      </div>
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-indigo-600 to-blue-600 flex items-center justify-center text-white text-xs font-medium shadow-sm">
        {userInitials}
      </div>
    </div>
  );
}

export default UserMessage;
